import React from "react";
const IconDiscount = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M9.59961 16.7999L17.9996 8.3999"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="10.7996"
      cy="8.4002"
      r="1.2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="17.3992"
      cy="15.5999"
      r="1.2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M22.7992 4.6001V19.4001C22.7992 19.9524 22.3515 20.4001 21.7992 20.4001H6.57954C6.22069 20.4001 5.88934 20.2078 5.7113 19.8962L1.48273 12.4962C1.30705 12.1888 1.30705 11.8114 1.48273 11.504L5.7113 4.10396C5.88934 3.79238 6.22068 3.6001 6.57954 3.6001H21.7992C22.3515 3.6001 22.7992 4.04781 22.7992 4.6001Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);
export default IconDiscount;
